import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { post } from '@/library/axios';
import type { MutationConfig } from '@/library/react-query';
import { displayError } from '@/utils/functions/displayError';

export type VerifySubscriptionReq = {
  orderId: string;
  paymentId: string;
  signature: string;
};

export const verifySubscription = ({
  customerId,
  payload,
  subscriptionId,
}: {
  customerId: string;
  payload: VerifySubscriptionReq;
  subscriptionId: string;
}): Promise<any> => {
  return post(
    `/customers/${customerId}/subscriptions/${subscriptionId}/verification`,
    payload
  );
};

type UseVerifySubscription = {
  config?: MutationConfig<typeof verifySubscription>;
};

export const useVerifySubscription = ({
  config,
}: UseVerifySubscription = {}) => {
  const mutation = useMutation({
    ...config,
    mutationFn: verifySubscription,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
